"use client";
import CheckInForm from "./CheckInForm";
import Form from "./form";
import LayoutWrapper from "./LayoutWrapper";
import PnrForm from "./PnrForm";

const FerrySearchFormWrapper = (props) => {
  return (
    <LayoutWrapper
      pnrFormComponent={props.hidePnrSection ? null : PnrForm}
      checkInFormComponent={CheckInForm}
      translationNamespace="common"
      scrollToForm={props.scrollToForm}
    >
      <Form {...props} />
    </LayoutWrapper>
  );
};

export default FerrySearchFormWrapper;
